// extracted by mini-css-extract-plugin
module.exports = {"page_container":"home_page_container__6495O"};